export default {
  General: {
    Email: "E-Mail",
    Send: "Senden",
    Done: "Fertig",
    Finish: "Fertig stellen",
    Try_again: "Erneut versuchen",
    or: "oder"
  },
  SamsungType: {
    bixby: "Mit Bixby",
    no_bixby: "Ohne Bixby",
    home_button: "Mit Home-Taste"
  },
  sendEmail: {
    repair_tip1: "Dieses Modell kann mit der mobilen App nicht repariert werden. Wir senden Ihnen die Desktop-Lösung per E-Mail zu.",
    check_tip1: "Die Geräteprüfung kann nicht nur mit der mobilen App abgeschlossen werden. Wir senden Ihnen die Desktop-Lösung per E-Mail zu.",
    tip1: "Dieses Modell kann mit der mobilen App nicht entsperrt werden. Wir senden Ihnen die Desktop-Lösung per E-Mail zu.",
    tip2: "Verbinden Sie Ihr Telefon für eine bessere Erfolgsrate über ein Datenkabel mit Ihrem Computer.",
    enter_address: "Geben Sie Ihre E-Mail-Adresse ein.",
    enter_correct_address: "Bitte geben Sie die richtige E-Mail-Adresse ein.",
    confidential: "Ihre E-Mail-Adresse wird streng vertraulich behandelt.",
    open_link: "Öffnen Sie {0} zum Download in einem beliebigen Browser.",
    has_sent: "Ihre E-Mail wurde gesendet",
    almost: "Fast geschafft",
    step1: "Schritt 1",
    open_email: "Öffnen Sie die E-Mail und verwenden Sie den Link, um die Desktop-Version von Dr.Fone herunterzuladen.",
    step2: "Schritt 2",
    repair_launch_tip: "Starten Sie Dr.Fone System Repair und melden Sie sich an, um die Reparaturfunktion zu verwenden.",
    check_launch_tip: "Installieren Sie die Dr.Fone-Desktopversion und melden Sie sich mit demselben Konto an. Klicken Sie auf „My Device“ und folgen Sie dann den Anweisungen auf dem Bildschirm, um Ihr Gerät zu verbinden. Sobald die Verbindung hergestellt ist, klicken Sie auf „Device Detail“, um die detaillierten Prüfergebnisse anzuzeigen.",
    launch_tip: "Starten Sie Dr.Fone „Entsperren“. Um die Entsperrfunktion zu nutzen, müssen Sie sich anmelden.",
    contact_us: "Kontaktieren Sie uns, wenn Sie Hilfe benötigen."
  },
  Unlock: {
    recoveryMode: "Versetzen Sie das Gerät in den Wiederherstellungsmodus",
    wipe_cache: "Löschen Sie die Cache-Partition auf Ihrem Gerät",
    wipe_data: "Befolgen Sie die Anweisungen zum Löschen von Daten auf Ihrem Gerät",
    completed: "Entsperren abgeschlossen",
    completed_tip: "Überprüfen Sie, ob die Bildschirmsperre erfolgreich entfernt wurde. Bei einem Fehlschlag: Versuchen Sie es erneut.",
    contact_us: "Entsperren fehlgeschlagen? Kontaktieren Sie uns für zusätzliche Unterstützung."
  },
  UnlockStep: {
    sa1: "1. Schalten Sie das Telefon aus und verbinden Sie es mit dem Computer ",
    sa2: "2. Halten Sie die Lauter-Taste + Bixby + Ein/Aus gleichzeitig gedrückt",
    sa3: "3. Lassen Sie die Tasten los, sobald das Samsung-Logo angezeigt wird, und warten Sie einige Sekunden",
    sa4: "4. Das Gerät sollte nun im Wiederherstellungsmodus starten. Wählen Sie „Bootloader neu starten“, um in den Download-Modus zu gelangen.",
    sb1: "1. Schalten Sie das Telefon aus und verbinden Sie es mit dem Computer",
    sb2: "2. Halten Sie Ein/Aus und die Lauter-Taste gleichzeitig gedrückt",
    sb3: "3. Halten Sie diese beiden Tasten weiterhin gedrückt, auch wenn das Gerät neu startet",
    sb4: "4. Das Gerät sollte nun im Wiederherstellungsmodus starten. Wählen Sie „Bootloader neu starten“, um in den Download-Modus zu gelangen.",
    sc1: "1. Schalten Sie das Telefon aus und verbinden Sie es mit dem Computer",
    sc2: "2. Halten Sie die Lauter-Taste + die Home-Taste + Ein/Aus gleichzeitig gedrückt",
    sc3: "3. Lassen Sie die Tasten los, sobald das Samsung-Logo angezeigt wird, und warten Sie einige Sekunden",
    sc4: "4. Das Gerät sollte nun im Wiederherstellungsmodus starten. Wählen Sie „Bootloader neu starten“, um in den Download-Modus zu gelangen.",
    s5: "5. Drücken Sie die Lautstärketaste, um „Daten löschen/Zurücksetzen auf Werkseinstellungen“ auszuwählen, und drücken Sie zur Bestätigung Ein/Aus",
    s6: "6. Drücken Sie die Lautstärketaste, um „Ja“ auszuwählen, und drücken Sie zur Bestätigung Ein/Aus",
    s7: "7. Wählen Sie „Cache-Partition löschen“ und anschließend „Ja“",
    s8: "8. Wählen Sie „System jetzt neu starten“ und drücken Sie zur Bestätigung Ein/Aus. Es dauert einige Zeit, bis das Gerät neu gestartet wird.",
    common1: "Schalten Sie Ihr Telefon aus.",
    common2: "Drücken Sie die Lauter-Taste und Ein/Aus für einige Sekunden.",
    common3: "Lassen Sie alle Tasten los, wenn der Wiederherstellungsmodus angezeigt wird.",
    m4: "Wählen Sie „Daten löschen“, indem Sie die Lautstärketasten und Ein/Aus zur Bestätigung verwenden.",
    m5: "Wählen Sie „Alle Daten löschen“.",
    m6: "Wählen Sie nun „Bestätigen“ und warten Sie, bis der Prozess beendet ist.",
    m7: "Kehren Sie mit Ein/Aus zum Hauptmenü zurück.",
    m8: "Wählen Sie „Neustart“.",
    m9: "Wählen Sie abschließend „System neu starten“.",
    h4: "Wählen Sie „Daten löschen“, indem Sie die Lautstärketasten und Ein/Aus zur Bestätigung verwenden.",
    h5: "Wählen Sie „Zurücksetzen auf Werkseinstellungen“.",
    h6: "Geben Sie das Wort „Ja“ ein und wählen Sie dann „Zurücksetzen auf Werkseinstellungen“.",
    h7: "Während dieses Vorgangs werden alle Ihre Dateien entfernt.",
    h8: "Wählen Sie „Zurück“, um zum Hauptmenü zurückzukehren.",
    h9: "Wählen Sie abschließend „Neustart“."
  }
};
